import AdventureEngine from './AdventureEngine'
import type { Adventure, AdventureProgress } from '../../types'

interface AdventureViewProps {
  adventure: Adventure
  onComplete: (progress: AdventureProgress) => void
  onExit: () => void
}

export default function AdventureView({ adventure, onComplete, onExit }: AdventureViewProps) {
  const handleComplete = (score: number, timeSpent: number) => {
    const progress: AdventureProgress = {
      adventureId: adventure.id,
      completedAt: new Date().toISOString(),
      score,
      timeSpent,
      quizzesCorrect: 0, // Calculated in engine
      quizzesTotal: 0
    }
    onComplete(progress)
  }

  return (
    <AdventureEngine
      adventure={adventure}
      onComplete={handleComplete}
      onExit={onExit}
    />
  )
}
